module.exports = __webpack_public_path__ + "static/media/ordfortaelsepreviewno.532faf3e.mp4";